import { Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

export const TextWrapper = styled.table`
  table-layout: fixed;
  width: 100%;
  word-wrap: break-word;
`;

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;

    & .tox-tinymce {
      flex: 1;
      border: none;
    }
  }
`;

export const Title = withStyles(({ palette }) => ({
  root: {
    color: palette.text.disabled,
    fontWeight: 600
  }
}))(Typography);

export const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0
  },
  subjectSection: {
    flexShrink: 0
  },
  bodySection: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0
  },
  subjectContainer: {
    fontSize: typography.body1.fontSize,
    fontFamily: typography.fontFamily,
    lineHeight: 1.5,
    '& p': {
      marginTop: 0
    }
  },
  variableStyles: {
    '& .mce-mergetag': {
      borderRadius: '25px',
      padding: '3px 8px 3px 8px',
      color: '#ffffff',
      backgroundColor: '#1E96FC'
    }
  },
  divider: {
    margin: '16px 0',
    flexShrink: 0
  }
}));
